import styled from 'styled-components'

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: fit-content;
    height: fit-content;
    transition: 0.1s;
`

export const Arrow = styled.span`
    border-bottom: 10px solid #dddee1;
    border-top-color: #dddee1;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
`

export const Body = styled.span`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    text-align: center;
    align-items: center;
    padding: 2px 8px;
    width: 128px;
    height: 20px;
    box-shadow: 5px teal;
    background: #dddee1;
    border-radius: 2px;
`

export const Icon = styled.i`
    font-style: normal;
    font-weight: 900;
    font-size: 14px;
    line-height: 16px;
    color: ${({ theme }) => theme['gray-600']};
`
export const Item = styled.span`
    width: 100%;
    height: 100%;
    background: transparent;
    cursor: pointer;
    &:hover {
        ${Icon} {
            color: ${({ theme }) => theme['gray-800']};
        }
    }
`
